(function checkboxPlugin(global) {
  "use strict";

  var SPECIAL_VALUE = global.DATE_SPECIAL_VALUE;
  var CONTROL_EVENT = global.SelectListControl.EVENT;

  /**
  * Плагин для добавления специавльных значений "Все", "Пустые", "Не пустые" для контрола SelectList
  * @class WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin
  * @extends WebAccess.Plugin
  * @property {string} name Имя плагина.  
  * @since 5.2.0.1300
  */
  global.DateValuesPlugin = WA.Plugin.extend({
    name: 'SpecialValuesPlugin',

    _selectList: null,
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Регистрация плагина.
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#register
    * @param {WebAccess.components.dataViews.gridPlugins._controls.selectList.SelectList} расширяемый экземпляр
    * @since 5.2.0.1300
    * @return {object} публичные методы доступные расширяемому объекту.
    */
    register: function (selectList) {
      var me = this;
      me._selectList = selectList
      .bind(CONTROL_EVENT.BEFORE_LIST_OPEN, $.proxy(me._beforeListOpen, me))
      .bind(CONTROL_EVENT.BEFORE_RECORDS_APPEND, $.proxy(me._beforeRecordsAppend, me))      
      return {};
    },
 
    /**
    * Признак того что были выбраны все записи
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_onRecordSelect
    * @return {Boolean}
    */
    _isAllSelected: function () {
      var me = this;      
      return me._selectList._jList.find('#' + SPECIAL_VALUE.ALL + '-list-option').is(':checked');
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
   
    /**
    * Проверка наличия значения в списке объектов
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_isExist
    * @param {string} value проверяемое значение
    * @return {Boolean}
    */
    _isExist: function (value, isInverted) {
      var me = this;
      var state = me._selectList.state;
      if (isInverted) {
        return !_(state.notSelectedRecords).where({ Value: value }).length;
      } else {
        return !!_(state.selectedRecords).where({ Value: value }).length;
      }
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Дополнение списка объектов спец.значениями при открытии списка
    * @private
    * @since 5.2.0.1300
    * @method WebAccess.components.dataViews.gridPlugins._controls.selectList.SpecialValuesPlugin#_beforeListOpen
    * @param {string} value проверяемое значение
    * @return {Boolean}
    */
    _beforeListOpen: function (selectList, byref_records) {
      var me = this;
      var isInverted = selectList.state.invertedMode;                    
      
      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.THIS_YEAR).makeSafeString(),
        value: SPECIAL_VALUE.THIS_YEAR,
        displayValue: L('CHOICE_THIS_YEAR'),
        type: SPECIAL_VALUE.THIS_YEAR,
        isSelected: me._isExist(SPECIAL_VALUE.THIS_YEAR, isInverted),
        classes: 'withBottomBorder'
      })

      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.THIS_MONTH).makeSafeString(),
        value: SPECIAL_VALUE.THIS_MONTH,
        displayValue: L('CHOICE_THIS_MONTH'),
        type: SPECIAL_VALUE.THIS_MONTH,
        isSelected: me._isExist(SPECIAL_VALUE.THIS_MONTH, isInverted)
      });

      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.THIS_WEEK).makeSafeString(),
        value: SPECIAL_VALUE.THIS_WEEK,
        displayValue: L('CHOICE_THIS_WEEK'),
        type: SPECIAL_VALUE.THIS_WEEK,
        isSelected: me._isExist(SPECIAL_VALUE.THIS_WEEK, isInverted)
      });

      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.TOMORROW).makeSafeString(),
        value: SPECIAL_VALUE.TOMORROW,
        displayValue: L('CHOICE_TOMORROW'),
        type: SPECIAL_VALUE.TOMORROW,
        isSelected: me._isExist(SPECIAL_VALUE.TOMORROW, isInverted)
      });

      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.TODAY).makeSafeString(),
        value: SPECIAL_VALUE.TODAY,
        displayValue: L('CHOICE_TODAY'),
        type: SPECIAL_VALUE.TODAY,
        isSelected: me._isExist(SPECIAL_VALUE.TODAY, isInverted)
      });

      byref_records.unshift({
        id: ("" + SPECIAL_VALUE.YESTERDAY).makeSafeString(),
        value: SPECIAL_VALUE.YESTERDAY,
        displayValue: L('CHOICE_YESTERDAY'),
        type: SPECIAL_VALUE.YESTERDAY,
        isSelected: me._isExist(SPECIAL_VALUE.YESTERDAY, isInverted)
      });
     
      return me;
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
    
  });

})(WA.components.dataViews.gridPlugins._controls.selectList);